// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__E7Frx","text":"PageNotFound_text__CPLI+"};